import type { FC, ReactNode } from 'react'
import type { BreadcrumbItem } from '@/types'

import Link from 'next/link'
import { ChevronRight } from 'lucide-react'

interface BreadcrumbsProps {
    items: Array<BreadcrumbItem>
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ items }): ReactNode => {
    return (
        <nav aria-label='Breadcrumb'>
            <ol className='flex flex-wrap items-center gap-x-1.5 gap-y-1 text-sm text-muted-foreground'>
                {items.map((item, index) => {
                    const isLast = index === items.length - 1

                    return (
                        <li key={item.path} className='flex items-center gap-1.5'>
                            {index > 0 && <ChevronRight aria-hidden='true' className='size-3.5 opacity-60' />}

                            {isLast
                                ? (
                                    <span aria-current='page' className='py-1 text-foreground'>
                                        {item.name}
                                    </span>
                                )
                                : (
                                    <Link
                                        href={item.path}
                                        className='rounded-sm py-1 underline-offset-4 transition-colors hover:text-foreground hover:underline'
                                    >
                                        {item.name}
                                    </Link>
                                )}
                        </li>
                    )
                })}
            </ol>
        </nav>
    )
}
